import { Link, useSearchParams } from 'react-router-dom'
import { AlertCircle } from 'lucide-react'

export function OAuthErrorPage() {
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error') || 'authentication_failed'
  
  const errorMessages: Record<string, string> = {
    authentication_failed: 'OAuth authentication failed. Please try again.',
    access_denied: 'Access was denied. Please grant the necessary permissions.',
    invalid_state: 'Invalid authentication state. Please try again.',
    provider_error: 'The authentication provider encountered an error.',
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <AlertCircle className="h-6 w-6 text-red-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Authentication Error
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            {errorMessages[error] || 'An unexpected error occurred during authentication.'}
          </p>
        </div>
        
        <div className="mt-8">
          <Link
            to="/auth/login"
            className="flex w-full justify-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
          >
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  )
}